export default function ContactCtrl($http, $scope) {

  $scope.submitContact = function (contact) {
    let c = $.param(contact);

    $http({
      method: 'POST',
      url: "https://" + __API_HOST__ + "/api3/contact",
      data: c,
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    }).then(
        function (result) {
          $scope.completed = true;
          $scope.error = false;
        },
        function (error) {
          $scope.error = true;
        });
  };
}
